import * as React from 'react';
import { cn } from '@/lib/cn.js';

// Simple native-select wrapper to keep things light. Use Radix Select for richer needs.
export const Select = React.forwardRef(function Select({ className, children, ...props }, ref) {
  return (
    <select
      ref={ref}
      className={cn(
        'flex h-9 w-full rounded-md border border-slate-300 bg-white px-3 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 disabled:opacity-50 dark:bg-slate-900 dark:border-slate-700 dark:text-slate-100',
        className,
      )}
      {...props}
    >
      {children}
    </select>
  );
});
